'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.PrintedDropdownField = exports.DropdownField = void 0

var _react = _interopRequireWildcard(require('react'))

var _reactDropdown = _interopRequireDefault(require('react-dropdown'))

require('react-dropdown/style.css')

var _styledComponents = _interopRequireWildcard(require('styled-components'))

var _index = require('../../atoms/Label/index.js')

var _index2 = require('../../atoms/Typography/index.js')

var _index3 = require('../Flex/index.js')

var _index4 = require('../TextField/index.js')

var _excluded = [
  'value',
  'error',
  'label',
  'onSave',
  'options',
  'disabled',
  'required',
  'inputClassName',
]

var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg)
    var value = info.value
  } catch (error) {
    reject(error)
    return
  }
  if (info.done) {
    resolve(value)
  } else {
    Promise.resolve(value).then(_next, _throw)
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args)
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value)
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err)
      }
      _next(undefined)
    })
  }
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  )
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen)
  var n = Object.prototype.toString.call(o).slice(8, -1)
  if (n === 'Object' && o.constructor) n = o.constructor.name
  if (n === 'Map' || n === 'Set') return Array.from(o)
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen)
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i]
  }
  return arr2
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator']
  if (_i == null) return
  var _arr = []
  var _n = true
  var _d = false
  var _s, _e
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value)
      if (i && _arr.length === i) break
    }
  } catch (err) {
    _d = true
    _e = err
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']()
    } finally {
      if (_d) throw _e
    }
  }
  return _arr
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/ _react['default'].createElement(
    'svg',
    props,
    /*#__PURE__*/ _react['default'].createElement('path', {
      d: 'M20.106.106L11.5 8.694 2.894.106.25 2.75 11.5 14 22.75 2.75 20.106.106z',
      fill: '#9D9D9D',
    })
  )
}

ArrowIcon.defaultProps = {
  width: '23',
  height: '14',
  viewBox: '0 0 23 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
}
var DropdownSaving = (0, _styledComponents.css)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      "\n  .Dropdown-placeholder {\n    visibility: hidden;\n    &::before {\n      position: absolute;\n      visibility: visible;\n      content: 'Saving...';\n      left: ",
      ';\n      color: ',
      ';\n      margin-right: ',
      ';\n    }\n  }\n  .Dropdown-placeholder.is-selected {\n    flex: 1;\n    border-radius: 3px;\n    color: #fff;\n    background-color: ',
      ';\n    visibility: hidden;\n    text-align: center;\n  }\n',
    ])),
  function (props) {
    return props.theme.spacing(1)
  },
  function (props) {
    return props.theme.colors.text
  },
  function (props) {
    return props.theme.spacing(0.5)
  },
  function (props) {
    return props.theme.colors.success
  }
)
var DropdownSaved = (0, _styledComponents.css)(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  .Dropdown-placeholder {\n    opacity: 0.7;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n  }\n  .Dropdown-placeholder.is-selected {\n    border-radius: 3px;\n    opacity: 1;\n    color: #fff;\n    background-color: ',
      ';\n    /* prettier-ignore */\n    padding: ',
      ' ',
      ";\n    text-align: center;\n    &::before {\n      content: '\u2713';\n      color: #fff;\n      margin-right: ",
      ';\n    }\n  }\n',
    ])),
  function (props) {
    return props.theme.colors.success
  },
  function (props) {
    return props.theme.spacing(0.5)
  },
  function (props) {
    return props.theme.spacing(1)
  },
  function (props) {
    return props.theme.spacing(0.5)
  }
)
var DropdownError = (0, _styledComponents.css)(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteral([
      '\n  .Dropdown-control {\n    background-color: ',
      ';\n  }\n  .Dropdown-control:hover {\n    background-color: ',
      ';\n  }\n',
    ])),
  function (props) {
    return props.theme.lighten(props.theme.colors.error)
  },
  function (props) {
    return props.theme.lighten(props.theme.colors.error)
  }
)
var StyledDropdown = (0, _styledComponents['default'])(_reactDropdown['default'])(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteral([
      '\n  && {\n    .Dropdown-control {\n      background-color: ',
      ';\n      border: none;\n      border-radius: 5px;\n      min-width: 165px;\n      height: 45px;\n      transition: none;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-right: ',
      ';\n    }\n    .Dropdown-control:hover {\n      background-color: ',
      ';\n    }\n    .Dropdown-disabled {\n      background-color: #eeee !important;\n      opacity: 0.6;\n    }\n    .Dropdown-menu {\n      border: 1px solid ',
      ';\n      border-radius: 5px;\n      ',
      ' {\n        max-height: 100px;\n        top: 0;\n      }\n    }\n    .Dropdown-option.is-selected {\n      background-color: ',
      ';\n      opacity: 0.5;\n    }\n    .Dropdown-option:hover {\n      background-color: ',
      ';\n    }\n    .Dropdown-arrow-wrapper {\n      display: flex;\n      align-items: center;\n    }\n    ',
      '\n  }\n',
    ])),
  function (props) {
    return props.theme.colors.input.background
  },
  function (props) {
    return props.theme.spacing(1.5)
  },
  function (props) {
    return props.theme.lighten(props.theme.colors.primary)
  },
  function (props) {
    return props.theme.colors.primary
  },
  function (props) {
    return props.theme.breakpoints.phones
  },
  function (props) {
    return props.theme.lighten(props.theme.colors.primary)
  },
  function (props) {
    return props.theme.lighten(props.theme.colors.primary)
  },
  function (props) {
    return props.saving ? DropdownSaving : props.error ? DropdownError : DropdownSaved
  }
)

var DropdownField = function DropdownField(_ref) {
  var value = _ref.value,
    error = _ref.error,
    label = _ref.label,
    onSave = _ref.onSave,
    options = _ref.options,
    disabled = _ref.disabled,
    required = _ref.required,
    inputClassName = _ref.inputClassName,
    fieldProps = _objectWithoutProperties(_ref, _excluded)

  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1]

  var saveData = /*#__PURE__*/ (function () {
    var _ref2 = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee(option) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                if (
                  !(
                    onSave &&
                    option.value !== (value === null || value === void 0 ? void 0 : value.value)
                  )
                ) {
                  _context.next = 5
                  break
                }

                setSaving(true)
                _context.next = 4
                return onSave(option)

              case 4:
                setSaving(false)

              case 5:
              case 'end':
                return _context.stop()
            }
          }
        }, _callee)
      })
    )

    return function saveData(_x) {
      return _ref2.apply(this, arguments)
    }
  })()

  return /*#__PURE__*/ _react['default'].createElement(
    _react['default'].Fragment,
    null,
    /*#__PURE__*/ _react['default'].createElement(
      _index.Label,
      {
        className: 'fs-unmask',
        required: required,
        error: !!error,
        disabled: disabled,
      },
      label
    ),
    /*#__PURE__*/ _react['default'].createElement(
      StyledDropdown,
      _extends(
        {
          disabled: disabled || saving,
          onChange: saveData,
          options: options,
          error: !!error,
          value: value,
          saving: saving,
          className: inputClassName,
        },
        fieldProps,
        {
          arrowClosed: saving
            ? /*#__PURE__*/ _react['default'].createElement(SavingWheel, null)
            : /*#__PURE__*/ _react['default'].createElement(StyledArrowIcon, null),
          arrowOpen: /*#__PURE__*/ _react['default'].createElement(StyledArrowIcon, {
            open: true,
          }),
        }
      )
    ),
    error &&
      /*#__PURE__*/ _react['default'].createElement(
        _index3.Flex,
        {
          justifyContent: 'flex-end',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _index2.Typography,
          {
            as: 'label',
            color: 'error',
            style: {
              opacity: error ? 1 : 0,
            },
          },
          error
        )
      )
  )
}

exports.DropdownField = DropdownField
var rotate = (0, _styledComponents.keyframes)(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteral([
      '\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n',
    ]))
)
var StyledArrowIcon = (0, _styledComponents['default'])(ArrowIcon)(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteral(['\n  width: 15px;\n  transform: ', ';\n'])),
  function (props) {
    return props.open ? 'rotate(180deg)' : 'none'
  }
)

var SavingWheel = _styledComponents['default'].div(
  _templateObject7 ||
    (_templateObject7 = _taggedTemplateLiteral([
      '\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  background: transparent;\n  border: 2px solid ',
      ';\n  border-bottom-color: transparent;\n  animation: ',
      ' 1s linear infinite;\n',
    ])),
  function (props) {
    return props.theme.colors.success
  },
  rotate
)
/*******  PRINTED DROPDOWN  *************/

var PrintedDropdownField = function PrintedDropdownField(_ref3) {
  var valueOnly = _ref3.valueOnly,
    label = _ref3.label,
    options = _ref3.options,
    value = _ref3.value
  return /*#__PURE__*/ _react['default'].createElement(
    _index3.Flex,
    {
      flexDirection: valueOnly ? 'row' : 'column',
      width: '100%',
    },
    /*#__PURE__*/ _react['default'].createElement(FieldLabel, null, label, ':'),
    /*#__PURE__*/ _react['default'].createElement(
      Grid,
      null,
      valueOnly
        ? /*#__PURE__*/ _react['default'].createElement(
            _index3.Flex,
            {
              key: label,
              margin: '0 0px 0 8px',
              alignItems: 'flex-end',
            },
            /*#__PURE__*/ _react['default'].createElement(
              _index4.StyledValue,
              {
                style: {
                  width: '15mm',
                },
              },
              '\u2714'
            )
          )
        : options.map(function (option, index) {
            return /*#__PURE__*/ _react['default'].createElement(
              _index3.Flex,
              {
                key: option + index,
                margin: '0 0px 0 8px',
                alignItems: 'flex-end',
              },
              /*#__PURE__*/ _react['default'].createElement(
                _index4.StyledValue,
                {
                  style: {
                    width: '10mm',
                  },
                },
                value === option ? '✔' : '  '
              ),
              /*#__PURE__*/ _react['default'].createElement(StyledLabel, null, option)
            )
          })
    )
  )
}

exports.PrintedDropdownField = PrintedDropdownField

var Grid = _styledComponents['default'].div(
  _templateObject8 ||
    (_templateObject8 = _taggedTemplateLiteral([
      '\n  flex: 1;\n  min-width: 100%;\n  margin-top: 4px;\n  display: grid;\n  grid-template-columns: 33% 33% 33%;\n',
    ]))
)

var FieldLabel = _styledComponents['default'].span(
  _templateObject9 ||
    (_templateObject9 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  padding-right: 4px;\n']))
)

var StyledLabel = _styledComponents['default'].span(
  _templateObject10 || (_templateObject10 = _taggedTemplateLiteral(['\n  padding-right: 4px;\n']))
)
